import { IconCheck } from '@tabler/icons-react';
import { IconCopy, IconEdit, IconEye, IconTrash } from '@tabler/icons-react';
import { useEffect, useState } from 'react';
import ModalItemPindah from './ModalItemPindah';

export default function DefaultItem({
  items,
  getItemEdit,
  handleCheckboxChange,
  showDetailItem,
  startIndex,
  selectedItems,
  getIdDelete,
  cabang,
}) {
  // console.log(selectedItems)
  const [copyItemId, setCopyItemId] = useState(null);

  const handleCopy = (id, nama) => {
    navigator.clipboard.writeText(nama);
    setCopyItemId(id);
    setTimeout(() => {
      setCopyItemId(null);
    }, 3000);
  };

  const [isOpenModalPindah, setOpenModalPindah] = useState(false);
  function closeModalPindah() {
    setOpenModalPindah(false);
  }
  


 

  return (
    <>
      <ModalItemPindah cabang={cabang} isOpenModalPindah={isOpenModalPindah} closeModalPindah={closeModalPindah} />
      {items.map((item, index) => (
        <tr
          key={item.id}
          onClick={(e) => {
            e.stopPropagation();
            showDetailItem(item.id);
          }}
          className="bg-white dark:bg-slate-900 border-b border-slate-200 dark:border-slate-700 hover:bg-amber-50/50 dark:hover:bg-slate-800 cursor-pointer transition-colors"
        >
          
          <td className="px-5 border-r border-slate-200/60 dark:border-slate-700/60 py-2.5 whitespace-nowrap font-medium text-slate-600 dark:text-slate-400 text-center">
            {startIndex + index + 1}.
          </td>
          <td className="px-4 border-r border-slate-200/60 dark:border-slate-700/60 py-2.5 whitespace-nowrap font-medium text-slate-700 dark:text-slate-300 flex items-center gap-1.5 h-full">
            <span className="mt-0.5">
              {copyItemId === item.id ? (
                <IconCheck className="w-5 h-5 text-green-500 stroke-2" />
              ) : (
                <IconCopy
                  className="cursor-pointer w-4 h-4 text-slate-400 hover:text-amber-500 dark:text-slate-500 dark:hover:text-amber-400 transition-colors"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCopy(item.id, item.kode_item)
                  }}
                  title="Salin Kode"
                />
              )}
            </span>
            {item.is_ready === true ? <span className="font-semibold text-slate-800 dark:text-slate-200">{item.kode_item}</span> : <span className="line-through text-slate-400 dark:text-slate-500">{item.kode_item}</span>}
          </td>
          <td className="px-5 border-r border-slate-200/60 dark:border-slate-700/60 py-2.5 whitespace-nowrap font-normal text-slate-600 dark:text-slate-300">{item.jenis_kategori?.nama_jenis}</td>

          <td className="px-5 border-r border-slate-200/60 dark:border-slate-700/60 py-2.5 whitespace-nowrap font-medium text-slate-700 dark:text-slate-300">
            {item.jenis_kategori.kategori.kode}{item.nomor_rak}
          </td>
          <td className="px-5 border-r border-slate-200/60 dark:border-slate-700/60 py-2.5 whitespace-nowrap font-normal text-slate-600 dark:text-slate-300">
            <span className="font-semibold text-slate-700 dark:text-slate-200">{item.berat}</span> gr <span className="text-slate-400 mx-1">|</span> {item.karat} krt
          </td>
          <td className="px-5 border-r border-slate-200/60 dark:border-slate-700/60 py-2.5 whitespace-nowrap font-medium text-amber-700 dark:text-amber-500 bg-amber-50/30 dark:bg-amber-900/10">{item.cabang?.nama_cabang}</td>
          <td className="px-5 border-r border-slate-200/60 dark:border-slate-700/60 py-2.5 whitespace-nowrap font-normal text-slate-500 dark:text-slate-400">{item.created_at}</td>
          
          <td className="px-4 border-r border-slate-200/60 dark:border-slate-700/60 py-2.5 whitespace-nowrap align-middle">
            <div className="flex items-center gap-1.5 justify-center">
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  showDetailItem(item.id)
                }}
                className="w-8 h-8 rounded-lg flex items-center justify-center text-teal-600 bg-teal-50 hover:bg-teal-500 hover:text-white dark:text-teal-400 dark:bg-teal-500/20 dark:hover:bg-teal-500 dark:hover:text-white transition-all shadow-sm hover:shadow"
                title="Lihat Detail"
              >
                <IconEye size={18} stroke={1.5} />
              </button>
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  getItemEdit(item.id)
                }}
                className="w-8 h-8 rounded-lg flex items-center justify-center text-blue-600 bg-blue-50 hover:bg-blue-500 hover:text-white dark:text-blue-400 dark:bg-blue-500/20 dark:hover:bg-blue-500 dark:hover:text-white transition-all shadow-sm hover:shadow"
                title="Edit Barang"
              >
                <IconEdit size={18} stroke={1.5} />
              </button>

              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  getIdDelete(item.id)
                }}
                className="w-8 h-8 rounded-lg flex items-center justify-center text-red-600 bg-red-50 hover:bg-red-500 hover:text-white dark:text-red-400 dark:bg-red-500/20 dark:hover:bg-red-500 dark:hover:text-white transition-all shadow-sm hover:shadow"
                title="Hapus Barang"
              >
                <IconTrash size={18} stroke={1.5} />
              </button>
            </div>
          </td>
          <td className="px-5 py-2.5 text-center whitespace-nowrap align-middle bg-slate-50/50 dark:bg-slate-800/40 group-hover:bg-amber-50/30 transition-colors">
            <input
              checked={selectedItems.some((si) => si.id === item.id)}
              onChange={(event) => handleCheckboxChange(event, item)}
              onClick={(e)=> e.stopPropagation()}
              type="checkbox"
              className="cursor-pointer checkbox checkbox-warning w-[22px] h-[22px] border-amber-400 hover:border-amber-500 dark:border-slate-500 dark:hover:border-amber-400 rounded transition-all shadow-sm"
              title="Pilih Barang"
            />
          </td>
        </tr>
      ))}
    </>
  );
}
